/* eslint-disable react/jsx-key */
import React from "react";
import { connect } from 'react-redux'
import styles from "../SidebarButton/Navbar.module.css";
import { getUserTypes } from 'SRC/modules/common/selectors'
import BiznisAdresariIkonica from "../SidebarButton/icons/BiznisAdresariIkonica";
import SidebarButton from "../SidebarButton/SidebarButton";
import Link from 'next/link'
import useTranslation from "next-translate/useTranslation";

const userTypesSlugs = {
  '/adresari': {
    en: '/service-providers',
    ua: '/posluhy',
    me: '/adresari',
    ru: '/uslugi',
  },
  '/auto-otpadi': {
    en: '/car-scrapyards',
    ua: '/avtomobilni-smittezvalishcha',
    me: '/auto-otpadi',
    ru: '/avtomobilnye-kladbishcha',
  },
  '/auto-saloni': {
    en: '/brand-representatives',
    ua: '/predstavnyky-brendu',
    me: '/auto-saloni',
    ru: '/predstaviteli-brenda',
  },
  '/auto-placevi': {
    en: '/car-dealerships',
    ua: '/avtosalony',
    me: '/auto-placevi',
    ru: '/avtosalony',
  },
  '/prodavnice': {
    en: '/stores',
    ua: '/magazyny',
    me: '/prodavnice',
    ru: '/magaziny',
  }
}

const BiznisAdresarDugme = ({ userTypes, isExpanded, onToggle, setIsSidebarOpen }) => {
  const { lang, t } = useTranslation("common");

  return (
    <div
      className={`${styles.sadrzajMainDugmeDrop} ${isExpanded ? styles.openDropdown : ""}`}
      onClick={onToggle}
    >
      <div className={styles.sadrzajMainDugmeDropDivDiv1}>
        <div className={styles.sadrzajDugmeDropDiv1}>
          <BiznisAdresariIkonica />
          <h3 className={`${styles.sadrzajMainDugmeTekstBiznis} ${styles.specialFont}`}>
            {t('Biznis adresar')}
          </h3>
        </div>
        <div className={styles.sadrzajDugmeDropDiv2}>
          <svg
            className={`${styles.sadrzajDugmeDropDiv2Strelica} ${isExpanded ? styles.rotirana : ""}`}
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon points="4,2 12,8 4,14" transform="rotate(180 8 8)" />
          </svg>
        </div>
      </div>

      {isExpanded && (
        <>
          <div className={styles.linijaDropDugme}></div>

          {(userTypes || []).filter(userType => userType.seo !== 'korisnik').map((userType) => (
            <Link
                key={userType.id}
              href={{
                pathname: '/users',
                query: {
                  userType: userType.seo
                }
              }}
              as={userType.seoPluLocalized}
            >
              <a>
                <SidebarButton text={userType.name} icon={userType.seoPlu} />
              </a>
            </Link>
          ))}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userTypes: getUserTypes(state),
  }
}

export default connect(mapStateToProps)(BiznisAdresarDugme);
